<agent-commissions-list>

    <div class="page-container">
        <!-- Header Section -->
        <div class="page-header mb-4">
            <div class="header-content">
                <h2 class="page-title mb-1">
                    <iconify-icon inline icon="mdi:cash-multiple" class="me-2 text-primary"></iconify-icon>
                    Commission History
                </h2>
                <p class="text-muted mb-0">View and manage your commission reports</p>
            </div>
            <div class="header-actions">
                <select class="form-select year-filter" onchange="{onYearFilter}">
                    <option value="{currentYear}">This Year ({currentYear})</option>
                    <option each="{year in state.years}" value="{year}">{year}</option>
                    <option value="all">All Reports</option>
                </select>
                <a href="{state.formURL}" class="btn btn-create">
                    <iconify-icon inline icon="material-symbols:add"></iconify-icon>
                    New Commission
                </a>
            </div>
        </div>

        <!-- Empty State -->
        <div if="{is.empty(state.commissions)}" class="empty-state">
            <div class="empty-state-icon">
                <iconify-icon icon="mdi:file-document-outline"></iconify-icon>
            </div>
            <h4>No Commission Reports Yet</h4>
            <p class="text-muted">You currently have no commission reports registered.</p>
            <a href="{state.formURL}" class="btn btn-create">
                <iconify-icon inline icon="material-symbols:add"></iconify-icon>
                Create Your First Report
            </a>
        </div>

        <!-- Commission Cards -->
        <div if="{!is.empty(state.commissions)}" class="commission-grid">
            <div each="{c in state.commissions}" class="commission-card">
                <div class="card-header-section">
                    <div class="agent-info">
                        <img class="agent-avatar"
                             src="https://sanmiguelrealestate.com/imgs/agent_sq/{c.staff.id}.webp"
                             alt="{c.staff.name_display}"
                             onerror="this.style.display='none';this.nextElementSibling.style.display='flex'"/>
                        <div class="agent-avatar-fallback" style="display:none;">
                            {c.staff.name_display.charAt(0)}
                        </div>
                        <div>
                            <h5 class="agent-name">{c.staff.name_display}</h5>
                            <span class="commission-type-badge">{c.commission_type}</span>
                            <span class="status-badge status-{c.status}">{c.status}</span>
                        </div>
                    </div>
                    <span class="date-badge">{fmt.datenice(c.contract_date)}</span>
                </div>

                <div class="card-body-section">
                    <div class="stat-row">
                        <div class="stat-item">
                            <span class="stat-label">Contract Amount</span>
                            <span class="stat-value">
                                {fmt.currency(c.commission_price)}
                                <span if="{c.commission_currency == 'MXN'}" class="currency-flag">
                                    <iconify-icon inline icon="twemoji:flag-mexico"></iconify-icon>
                                </span>
                            </span>
                        </div>
                        <div class="stat-item">
                            <span class="stat-label">Rate</span>
                            <span class="stat-value rate">{fmt.percent(c.commission_agency)}</span>
                        </div>
                        <div class="stat-item highlight">
                            <span class="stat-label">Realty Commission</span>
                            <span class="stat-value commission-amount">
                                {fmt.currency(c.commission_agency_total)}
                                <span if="{c.commission_currency == 'MXN'}" class="currency-flag">
                                    <iconify-icon inline icon="twemoji:flag-mexico"></iconify-icon>
                                </span>
                            </span>
                        </div>
                    </div>
                </div>

                <div class="card-footer-section">
                    <div class="footer-row">
                        <span class="paid-status {c.agency_paid ? 'paid' : 'unpaid'}">
                            <iconify-icon inline icon="{c.agency_paid ? 'mdi:check-circle' : 'mdi:clock-outline'}"></iconify-icon>
                            {c.agency_paid ? 'Paid' : 'Unpaid'}
                        </span>
                        <a data-cid="{c.ID}" class="btn btn-edit" href="form.html?edit_id={c.ID}">
                            <iconify-icon inline icon="material-symbols:edit-document"></iconify-icon>
                            View Details
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <style>
        agent-commissions-list {
            display: block;
            background: #f8f9fa;
            min-height: 100vh;
        }

        .page-container {
            max-width: 700px;
            margin: 0 auto;
            padding: 1.5rem 1rem;
        }

        @media (min-width: 1200px) {
            .page-container {
                max-width: 900px;
            }
        }

        .page-header {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            gap: 1rem;
            flex-wrap: wrap;
        }

        .header-content {
            flex: 1;
            min-width: 200px;
        }

        .header-actions {
            display: flex;
            align-items: center;
            gap: 1rem;
            flex-shrink: 0;
        }

        .year-filter {
            padding: 0.5rem 2rem 0.5rem 1rem;
            border: 1px solid #e2e8f0;
            border-radius: 8px;
            background: white;
            color: #4a5568;
            font-weight: 500;
            cursor: pointer;
            min-width: 160px;
        }

        .year-filter:focus {
            outline: none;
            border-color: #e53e3e;
            box-shadow: 0 0 0 3px rgba(229, 62, 62, 0.1);
        }

        .page-title {
            font-size: 1.75rem;
            font-weight: 600;
            color: #2d3748;
            margin: 0;
        }

        .btn-create {
            flex-shrink: 0;
            white-space: nowrap;
            background: linear-gradient(135deg, #e53e3e 0%, #c53030 100%);
            color: white;
            border: none;
            padding: 0.625rem 1.25rem;
            border-radius: 8px;
            font-weight: 500;
            transition: all 0.2s ease;
            box-shadow: 0 2px 4px rgba(229, 62, 62, 0.3);
        }

        .btn-create:hover {
            background: linear-gradient(135deg, #c53030 0%, #9b2c2c 100%);
            color: white;
            transform: translateY(-1px);
            box-shadow: 0 4px 8px rgba(229, 62, 62, 0.4);
        }

        /* Empty State */
        .empty-state {
            text-align: center;
            padding: 4rem 2rem;
            background: white;
            border-radius: 12px;
            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
        }

        .empty-state-icon {
            font-size: 4rem;
            color: #cbd5e0;
            margin-bottom: 1rem;
        }

        .empty-state h4 {
            color: #2d3748;
            margin-bottom: 0.5rem;
        }

        /* Commission Grid */
        .commission-grid {
            display: flex;
            flex-direction: column;
            gap: 1.25rem;
        }

        .commission-card {
            background: white;
            border-radius: 12px;
            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08), 0 1px 2px rgba(0, 0, 0, 0.06);
            overflow: hidden;
            transition: all 0.2s ease;
            border: 1px solid #e2e8f0;
        }

        .commission-card:hover {
            box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
            transform: translateY(-2px);
        }

        .card-header-section {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            padding: 1.25rem 1.25rem 0.75rem;
            border-bottom: 1px solid #f0f0f0;
        }

        .agent-info {
            display: flex;
            align-items: center;
            gap: 0.75rem;
        }

        .agent-avatar {
            width: 42px;
            height: 42px;
            border-radius: 10px;
            object-fit: cover;
            flex-shrink: 0;
        }

        .agent-avatar-fallback {
            width: 42px;
            height: 42px;
            border-radius: 10px;
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            color: white;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: 600;
            font-size: 1.1rem;
            flex-shrink: 0;
        }

        .agent-name {
            margin: 0;
            font-size: 1rem;
            font-weight: 600;
            color: #2d3748;
        }

        .commission-type-badge {
            display: inline-block;
            padding: 0.2rem 0.6rem;
            background: #edf2f7;
            color: #4a5568;
            border-radius: 4px;
            font-size: 0.75rem;
            font-weight: 500;
            text-transform: capitalize;
        }

        .status-badge {
            display: inline-block;
            padding: 0.2rem 0.6rem;
            border-radius: 4px;
            font-size: 0.75rem;
            font-weight: 500;
            text-transform: capitalize;
            margin-left: 0.35rem;
        }

        .status-badge.status-pending {
            background: #fef3c7;
            color: #92400e;
        }

        .status-badge.status-approved {
            background: #c6f6d5;
            color: #276749;
        }

        .status-badge.status-rejected {
            background: #fed7d7;
            color: #c53030;
        }

        .date-badge {
            font-size: 0.8rem;
            color: #718096;
            background: #f7fafc;
            padding: 0.35rem 0.75rem;
            border-radius: 6px;
        }

        .card-body-section {
            padding: 1rem 1.25rem;
        }

        .stat-row {
            display: flex;
            justify-content: space-between;
            gap: 1rem;
        }

        .stat-item {
            flex: 1;
            text-align: center;
            padding: 0.5rem;
        }

        .stat-item.highlight {
            background: linear-gradient(135deg, #f0fff4 0%, #c6f6d5 100%);
            border-radius: 8px;
        }

        .stat-label {
            display: block;
            font-size: 0.75rem;
            color: #718096;
            text-transform: uppercase;
            letter-spacing: 0.5px;
            margin-bottom: 0.25rem;
        }

        .stat-value {
            display: block;
            font-size: 1rem;
            font-weight: 600;
            color: #2d3748;
        }

        .stat-value.rate {
            color: #667eea;
        }

        .stat-value.commission-amount {
            color: #38a169;
            font-size: 1.1rem;
        }

        .currency-flag {
            margin-left: 0.25rem;
        }

        .card-footer-section {
            padding: 0.75rem 1.25rem 1.25rem;
        }

        .footer-row {
            display: flex;
            justify-content: space-between;
            align-items: center;
            gap: 1rem;
        }

        .paid-status {
            display: inline-flex;
            align-items: center;
            gap: 0.35rem;
            padding: 0.4rem 0.75rem;
            border-radius: 6px;
            font-size: 0.85rem;
            font-weight: 500;
        }

        .paid-status.paid {
            background: #c6f6d5;
            color: #276749;
        }

        .paid-status.unpaid {
            background: #fed7d7;
            color: #c53030;
        }

        .btn-edit {
            display: inline-flex;
            align-items: center;
            gap: 0.5rem;
            padding: 0.5rem 1rem;
            background: #f7fafc;
            color: #4a5568;
            border: 1px solid #e2e8f0;
            border-radius: 8px;
            font-weight: 500;
            font-size: 0.85rem;
            transition: all 0.2s ease;
            text-decoration: none;
        }

        .btn-edit:hover {
            background: #edf2f7;
            color: #2d3748;
            border-color: #cbd5e0;
        }

        @media (max-width: 768px) {
            .stat-row {
                flex-wrap: wrap;
            }

            .stat-item {
                min-width: calc(50% - 0.5rem);
            }
        }
    </style>


    <script>
        import Swal from 'sweetalert2';
        import dayjs from 'dayjs';
        import { api_get } from '../../lib/api';
        export default {
            state: {
                user_id: 0,
                user_username: '',
                role: false,
                commissions: [],
                allCommissions: [],
                years: [],
                selectedYear: null,
                formURL: '/form.html'
            },
            currentYear: new Date().getFullYear(),
            onBeforeMount() {
                this.state.selectedYear = this.currentYear;

                if(this._user && this._user.id) {
                    this.state.user__id = this._user.id;
                    this.state.user_id = this.query_params.staff || this._user.id;
                    this.state.user_username = this._user.username;
                    this.state.role = this._user.role;
                }else{
                    this.state.user_id = this.query_params.staff;
                    this.state.user__id = this.query_params.user;
                    this.state.username = this.query_params.name;
                    this.state.admin = false;
                }

                this.state.formURL = '/form.html?user='+this.state.user__id+'&staff='+this.state.user_id+'&name='+this.state.username;

                console.log("Agent Before Mount");
            },
            onMounted() {
                this.getList();
                console.log("Agent Mounted");
            },
            getList(){
                return api_get('/commission/agent/' + this.state.user_id).then((res)=>{
                    console.log(res);
                    if(res.status == 200 && !res.data.success){
                        const allCommissions = res.data;
                        const years = this.extractYears(allCommissions);
                        const filtered = this.filterByYear(allCommissions, this.currentYear);

                        this.update({
                            allCommissions: allCommissions,
                            commissions: filtered,
                            years: years
                        });

                    }else{
                        Swal.fire({
                            icon: 'error',
                            title: 'Oops...',
                            text: 'Something went wrong! Could not get agent data.',
                        });
                    }
                });
            },

            extractYears(commissions) {
                const currentYear = this.currentYear;
                const yearsSet = new Set();

                commissions.forEach(c => {
                    if(c.contract_date) {
                        const year = dayjs(c.contract_date).year();
                        if(year !== currentYear) {
                            yearsSet.add(year);
                        }
                    }
                });

                return Array.from(yearsSet).sort((a, b) => b - a);
            },

            filterByYear(commissions, year) {
                if(year === 'all') {
                    return commissions;
                }

                return commissions.filter(c => {
                    if(!c.contract_date) return false;
                    return dayjs(c.contract_date).year() === parseInt(year);
                });
            },

            onYearFilter(e) {
                const year = e.target.value;
                this.state.selectedYear = year;
                const filtered = this.filterByYear(this.state.allCommissions, year);
                this.update({
                    commissions: filtered
                });
            },

            onEdit(e) {
                const el = e.target.closest('button');
                const cid = el.dataset.cid || false;
                console.log(cid);
            },
        }
    </script>
</agent-commissions-list>
